import { useAgTechAuthContext } from "@agtech/core/auth/AgTechAuthContext";
import AgTechQueryLoadingSurface from "@agtech/core/data/queries/AgTechQueryLoadingSurface";
import { useUserDataGetCurrentUserQuery } from '@agtech/data/users/AgTechUserQueries';
import { useAgTechWebAppContext } from "../../../components/App/Contexts/AgTechWebAppContext";
import { AgTechButton } from "../../../components/Buttons/AgTechButtons";
import AgTechHeaderDetail from "../../../components/Headers/AgTechHeaderDetail";

const AgTechUserDetailPopup = () => {
    let appContext = useAgTechWebAppContext();
    let authContext = useAgTechAuthContext();

    const userDetailsQuery = useUserDataGetCurrentUserQuery();

    return (
        <div className='row-based container' style={{ width: 360 }}>
            <AgTechQueryLoadingSurface query={userDetailsQuery}>
                {(user) => (
                    <div className='row-based stretched flex'>
                        <AgTechHeaderDetail
                            header={user.firstName + ' ' + user.lastName}
                            detail={user.userName}
                            settings={{
                                classes: 'p-4',
                                badge: {
                                    icon: 'fas fa-user-circle'
                                }
                            }}
                        />
                        <div className="px-4 py-3 column-based-vertically-centered top-bordered container">
                            <AgTechButton
                                text="Logout"
                                classes='ml-auto button-highlight'
                                action={() => {
                                    appContext.confirmations.askForConfirmation({
                                        content: {
                                            header: "Are you sure you want to log out?",
                                            confirmationButtonText: "Log Out"
                                        },
                                        actions: {
                                            onCancel: () => {},
                                            onConfirm: async () => {
                                                await authContext.logoutUser();
                                                return true;
                                            }
                                        }
                                    })
                                }}
                            />
                        </div>
                    </div>
                )}
            </AgTechQueryLoadingSurface>
        </div>
    )
}

export default AgTechUserDetailPopup;